import(/* webpackMode: "eager", webpackExports: ["Card","Avatar","CardBody"] */ "/app/node_modules/.pnpm/@olinfo+react-components@0.12.0_react@19.1.1/node_modules/@olinfo/react-components/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonateButton"] */ "/app/src/app/(training)/user/[username]/impersonate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateTime"] */ "/app/src/components/date.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/components/link.tsx");
